import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  isHelpDisplayed: false,
  isExpanded: false,
  shouldAutoHide: true,
};

const helpPanelReducer = (state = initialState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }
  switch (type) {
    case REDUX_ACTIONS.INITIALIZE_STANDARD_ITEM:
      return initialState;

    case REDUX_ACTIONS.EXPAND_HELP_PANEL:
      return {
        ...state,
        isExpanded: true,
        shouldAutoHide: payload.shouldAutoHide,
      };

    case REDUX_ACTIONS.SHOW_HELP_TEXT:
      return {
        ...state,
        isHelpDisplayed: true,
      };

    case REDUX_ACTIONS.HIDE_HELP_TEXT:
      return {
        ...state,
        isExpanded: false,
        isHelpDisplayed: false,
      };

    case REDUX_ACTIONS.SET_SELECTED_INFERENCE_INDEX:
      return {
        ...state,
        isExpanded: true,
        shouldAutoHide: false,
      };

    case REDUX_ACTIONS.DESELECT_INFERENCE:
      return {
        ...state,
        isExpanded: false,
        isHelpDisplayed: false,
      };

    default:
      return state;
  }
};

export default helpPanelReducer;
